import React from "react";
import ChangePassword from "../components/ChangePassword/ChangePassword"; // ✅ Import component

const ChangePasswordPage = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <ChangePassword />
    </div>
  );
};

export default ChangePasswordPage;
